export default __webpack_public_path__ + "static/media/banana.a00aa7a4.jpg";